<app-header title="Manage Campaigns"></app-header>
<ng-container [formGroup]="sponsor">
    <div>
        <div class="row">
            <div class="col-4">
                <div class="position-relative w-100">
                    <div
                        *ngIf="sponsor.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                    >
                        <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                    </div>
                    <div
                        *ngIf="sponsor.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                        style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                        class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                    >
                        <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetImage()"></app-icon-delete>
                    </div>
                    <img style="border-radius: 5px" class="w-100" [src]="sponsor.controls.imageDataUrl.value">
                </div>
                <div *ngIf="sponsor.controls.imageUrl.touched"  class="mat-form-field-description pb-3 text-center">
                  <div class="mat-error">{{ getSponsorImageErrorMessage() }}</div>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-4 text-center">
                @if(sponsor.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal()" class="blue-text body-2">Choose from previously used images</a>
                }
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <mdb-form-control class="form-fill" >
                    <app-mdbp-input mdbInput formControlName="name" label='Sponsor Name'></app-mdbp-input>
                    <mdb-error class="form-fill-error"  *ngIf="sponsor.controls.name.hasError('required') && sponsor.controls.name.touched">Please provide Name</mdb-error>
                </mdb-form-control>

              <mdb-form-control class="form-fill">
                <app-mdbp-input mdbInput formControlName="sponsorUrl" label='Sponsor Url'></app-mdbp-input>
                <span class="form-fill-error"  *ngIf="sponsor.controls.sponsorUrl.hasError('pattern') && sponsor.controls.sponsorUrl.touched">Incorrect format of Sponsor URL</span>
                <span class="form-fill-error"  *ngIf="sponsor.controls.sponsorUrl.hasError('url') && sponsor.controls.sponsorUrl.touched">Incorrect format of Sponsor URL</span>
              </mdb-form-control>
            </div>
        </div>
    </div>

</ng-container>
